import {BatchSummary} from 'constants/SampleConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import {RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';
import * as net from 'util/Net';
import {
  Workflow,
  WorkflowDashboardDetails,
  WorkflowDetails,
  WorkflowSummary,
} from 'workflows/WorkflowConstants';

export interface WorkflowResponse {
  workflow: Workflow;
}

export interface CreateWorkflowParams {
  workflowTemplateVersionId?: string | null;
  rootFolderId: string;
  name: string;
  prefix?: string;
  fulfillments?: Array<RequestFulfillmentDefinition>;
}

export function createWorkflow({
  workflowTemplateVersionId,
  rootFolderId,
  name,
  prefix,
  fulfillments,
}: CreateWorkflowParams): JQueryPromise<WorkflowResponse> {
  return net.postJSON({
    url: '/1/api/workflows',
    data: {
      workflowTemplateVersionId,
      rootFolderId,
      name,
      prefix,
      fulfillments,
    },
  });
}

export function deleteWorkflow(workflowId: string): JQueryPromise<{}> {
  return net.delete_({
    url: `/1/api/workflows/${workflowId}`,
  });
}

export interface EditWorkflowMetadataParams {
  name?: string;
  description?: string;
  rootFolderId?: string;
  authorIds?: Array<string>;
}

export function editWorkflowMetadata(
  workflowId: string,
  {name, description, rootFolderId, authorIds}: EditWorkflowMetadataParams
): JQueryPromise<WorkflowResponse> {
  return net.patchJSON({
    url: `/1/api/workflows/${workflowId}`,
    data: {name, description, rootFolderId, authorIds},
  });
}
export interface ListWorkflowsResponse {
  workflowSummaries: Array<WorkflowSummary>;
}

export function bulkFetchSummaries(workflowIds: Array<string>): Promise<{[id: string]: WorkflowSummary}> {
  return net.postJSONPromise({
    url: '/1/api/workflows:bulk-get-summaries',
    data: {workflowIds},
  });
}

export function fetchWorkflowDetails(workflowId: string): Promise<WorkflowDetails> {
  return net.getJSONPromise(`/1/api/workflows/${workflowId}/details`);
}

export interface InitializeWorkflowParams {
  workflowId: string;
  initialStageRunParams: Array<{batchId: string} | {fileId: string}>;
}

export function initializeWorkflow({
  workflowId,
  initialStageRunParams,
}: InitializeWorkflowParams): JQueryPromise<WorkflowDetails> {
  return net.postJSON({
    url: `/1/api/workflows/${workflowId}:initialize`,
    data: {initialStageRunParams},
  });
}

export function bulkFetchWorkflowDashboardDetails(
  workflowIds: Array<string>
): Promise<{[workflowIds: string]: WorkflowDashboardDetails}> {
  return net.postJSONPromise({url: '/1/api/workflows/details:bulk-get', data: {workflowIds}});
}

export interface ParseWorkflowInputSpreadsheetResponse {
  samples: Array<{
    batchSummary: BatchSummary | null;
    entitySummary: BioentitySummary | null;
  }>;
}

export function parseWorkflowInputSpreadsheet(
  spreadsheetUrl: string,
  spreadsheetName: string
): Promise<ParseWorkflowInputSpreadsheetResponse> {
  return net.postJSONPromise({
    url: `/1/api/workflows:get-samples-from-spreadsheet`,
    data: {spreadsheetUrl, spreadsheetName},
  });
}
